/**
 * @generated SignedSource<<9481b181befd08372d8f3caef58ed6f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type SitesFilterInput = {
  isActive?: ActiveRecords | null | undefined;
  schoolYearEndsBeforeOrOn?: any | null | undefined;
  siteIds?: ReadonlyArray<string> | null | undefined;
  userId?: string | null | undefined;
};
export type SitesQuery$variables = {
  sitesFilter?: SitesFilterInput | null | undefined;
  skip?: boolean | null | undefined;
};
export type SitesQuery$data = {
  readonly sites?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly name: string | null | undefined;
      readonly siteStandardStateCurriculums: ReadonlyArray<{
        readonly standardStateCurriculum: {
          readonly curriculum: {
            readonly targetGroups: ReadonlyArray<{
              readonly id: string;
              readonly name: string | null | undefined;
              readonly standardGrade: {
                readonly id: string;
                readonly name: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly siteTargetGroups: ReadonlyArray<{
        readonly targetGroup: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly standardState: {
        readonly id: string;
        readonly stateStandardName: string | null | undefined;
      } | null | undefined;
      readonly summary: string | null | undefined;
      readonly targetGroups: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly timeZone: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SitesQuery = {
  response: SitesQuery$data;
  variables: SitesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sitesFilter"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Variable",
    "name": "sitesFilterInput",
    "variableName": "sitesFilter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetGroupNode",
  "kind": "LinkedField",
  "name": "targetGroups",
  "plural": true,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "isActive": "ACTIVE"
    }
  }
],
v9 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "TargetGroupNode",
  "kind": "LinkedField",
  "name": "targetGroups",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StandardGradeNode",
      "kind": "LinkedField",
      "name": "standardGrade",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": "targetGroups(filter:{\"isActive\":\"ACTIVE\"})"
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetGroupNode",
  "kind": "LinkedField",
  "name": "targetGroup",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeZoneNode",
  "kind": "LinkedField",
  "name": "timeZone",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "StandardStateNode",
  "kind": "LinkedField",
  "name": "standardState",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stateStandardName",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SitesQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SiteNodeConnection",
            "kind": "LinkedField",
            "name": "sites",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SiteNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "concreteType": "SiteStandardStateCurriculumNode",
                    "kind": "LinkedField",
                    "name": "siteStandardStateCurriculums",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StandardStateCurriculumNode",
                        "kind": "LinkedField",
                        "name": "standardStateCurriculum",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CurriculumNode",
                            "kind": "LinkedField",
                            "name": "curriculum",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "siteStandardStateCurriculums(filter:{\"isActive\":\"ACTIVE\"})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SiteTargetGroupNode",
                    "kind": "LinkedField",
                    "name": "siteTargetGroups",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SitesQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "SiteNodeConnection",
            "kind": "LinkedField",
            "name": "sites",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SiteNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": (v8/*: any*/),
                    "concreteType": "SiteStandardStateCurriculumNode",
                    "kind": "LinkedField",
                    "name": "siteStandardStateCurriculums",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StandardStateCurriculumNode",
                        "kind": "LinkedField",
                        "name": "standardStateCurriculum",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CurriculumNode",
                            "kind": "LinkedField",
                            "name": "curriculum",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": "siteStandardStateCurriculums(filter:{\"isActive\":\"ACTIVE\"})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SiteTargetGroupNode",
                    "kind": "LinkedField",
                    "name": "siteTargetGroups",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0e7b18351165e7becf4e4f248aeeffc9",
    "id": null,
    "metadata": {},
    "name": "SitesQuery",
    "operationKind": "query",
    "text": "query SitesQuery(\n  $sitesFilter: SitesFilterInput\n  $skip: Boolean = false\n) {\n  sites(sitesFilterInput: $sitesFilter, first: 100) @skip(if: $skip) {\n    nodes {\n      id\n      summary\n      name\n      isActive\n      targetGroups {\n        id\n        name\n      }\n      siteStandardStateCurriculums(filter: {isActive: ACTIVE}) {\n        standardStateCurriculum {\n          curriculum {\n            targetGroups(filter: {isActive: ACTIVE}) {\n              id\n              name\n              standardGrade {\n                id\n                name\n              }\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n      siteTargetGroups {\n        targetGroup {\n          id\n          name\n        }\n        id\n      }\n      timeZone {\n        id\n        name\n      }\n      standardState {\n        id\n        stateStandardName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d07a82f07ffb25d92243fdf1de2df184";

export default node;
